import { Button, OTPInput } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import { API_ENDPOINT } from "../../../../constants/appConstant";
import { useNetwork } from "../../../../hooks/useNetwork";
import { EmailOTPProps } from "../../../../types";
import { getSiteProps } from "../../../../utils/siteProps";
import { Heading } from "../../common/Heading";

type NetworkType = {
  actionType: string;
  [key: string]: any;
};

export const EmailOTP = ({
  updateStepHandler,
  email,
  mobileNumber,
  countryCode,
  toast,
  otpId,
  nextApopType,
  onCTA,
  closeApop,
}: EmailOTPProps) => {
  const siteProps = getSiteProps(window.location.host);
  const [showResend, setShowResend] = useState(false);
  const [emailOTPId, setEmailOTPId] = useState(otpId);
  const [otpValue, setOTPValue] = useState("");
  const { response: fetchResponse, fetchData: fetchAPI } = useNetwork();
  const { response: apiResponse, fetchData: submitFetchApi } = useNetwork();

  const handleResendClick = async () => {
    getOTP();
    setOTPValue("");
    setShowResend(false);
  };

  const otpUpdateHandler = (newOTP: string) => {
    setOTPValue(newOTP);
  };

  const verifyEmailOtpHandler = async () => {
    const res = await submitFetchApi(
      `${API_ENDPOINT().seekerProfile.verifyEmailOTPMiddleware}`,
      "POST",
      {},
      {
        email: {
          email: email,
        },
        otp: otpValue,
        otpId: emailOTPId,
      },
    );

    if ((res?.error as { status?: number })?.status === 401) {
      window.location.href = "/rio/logout";
      return;
    }

    if ((res?.data as any)?.successMessage) {
      if (
        siteProps?.site_map !== "rexmonster" &&
        (!mobileNumber || !countryCode)
      ) {
        updateStepHandler("ADD_NUMBER");

        onCTA && onCTA("EMAIL_OTP");
        toast({
          showToast: true,
          text: "Section updated successfully",
          type: "success",
        });
      } else {
        // validate api call
        const validateRes = await fetchAPI(
          `${API_ENDPOINT().seekerProfile.validateProfileMiddleware}`,
          "GET",
        );

        if (validateRes.data) {
          const { actionType: apiActionType, ...rest } =
            validateRes.data as NetworkType;
          nextApopType(apiActionType, rest);

          onCTA && onCTA("EMAIL_OTP");
          toast({
            showToast: true,
            text: "Section updated successfully",
            type: "success",
          });
        } else {
          toast({
            showToast: true,
            text: "Something went wrong!",
            type: "error",
          });
        }
      }
    } else if (apiResponse.error) {
      toast({
        showToast: true,
        text: JSON.parse(apiResponse.error ?? "").errorMessage,
        type: "error",
      });
    }
  };

  const getOTP = async () => {
    if (showResend) {
      const res = await fetchAPI(
        `${API_ENDPOINT().seekerProfile.sendEmailOTPMiddleware}`,
        "POST",
        {},
        { email: email },
      );

      if ((res?.error as { status?: number })?.status === 401) {
        window.location.href = "/rio/logout";
        return;
      }

      const id = (res?.data as any)?.id;

      if (id) {
        setEmailOTPId(id);
        updateStepHandler("EMAIL_OTP");
        toast({
          showToast: true,
          text: "OTP sent successfully",
          type: "success",
        });
      } else {
        toast({
          showToast: true,
          text: "Something went wrong!",
          type: "error",
        });
      }
    }
  };

  useEffect(() => {
    if (!showResend) {
      setTimeout(() => {
        setShowResend(true);
      }, 20000);
    }
  }, [showResend]);

  return (
    <>
      <Heading
        headingText={"Update contact details"}
        onCloseBtnClickHandler={closeApop}
        isMobile={window.innerWidth < 786}
      />
      <div
        className="l1-mb-16 l1-mt-14 l1-flex l1-w-full l1-flex-col l1-gap-6 md:l1-mb-12 md:l1-mt-12"
        id="emailOTPForm"
      >
        <div className="l1-mx-2 l1-flex l1-flex-col l1-gap-4">
          <p className="l1-text-sm l1-text-content-secondary">
            We have sent an OTP to your email id:
            <br />
            <span>{email}</span>
          </p>

          <div className="l1-flex l1-flex-col l1-gap-2">
            <p className="l1-text-sm l1-text-gray-500">Enter OTP</p>
            <OTPInput
              otpValue={otpValue}
              otpUpdateHandler={otpUpdateHandler}
              resendClickHandler={handleResendClick}
              resendTime={60}
            />
          </div>
        </div>

        <div className="l1-fixed l1-bottom-0 l1-left-0 l1-z-10 l1-flex l1-w-full l1-max-w-full l1-gap-2 l1-bg-white l1-px-4 l1-py-3 l1-shadow-black-sm md:!l1-px-8 md:l1-py-4">
          <div className="l1-w-full">
            <Button
              className="!l1-w-full !l1-py-3"
              label="Verify Email ID"
              modifier="primary"
              type="button"
              onClick={() => verifyEmailOtpHandler()}
              isLoading={apiResponse.isLoading || fetchResponse.isLoading}
              disabled={otpValue.length === 6 ? false : true}
            />
          </div>
        </div>
      </div>
    </>
  );
};
